import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1b3428e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#example5" }),
  /*#__PURE__*/_createTextVNode(" Select with custom options slot ")
], -1))
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = { class: "bg-dark text-white rounded-1 mb-2 p-3" }
const _hoisted_5 = { class: "multiselect-single-label" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_CodeHighlighter2 = _resolveComponent("CodeHighlighter2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, " Data: " + _toDisplayString(_ctx.example5.value), 1),
      _createVNode(_component_Multiselect, _mergeProps({
        modelValue: _ctx.example5.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.example5.value) = $event))
      }, _ctx.example5), {
        singlelabel: _withCtx(({ value }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "character-label-icon",
              src: value.icon
            }, null, 8, _hoisted_6),
            _createTextVNode(" " + _toDisplayString(value.name), 1)
          ])
        ]),
        option: _withCtx(({ option }) => [
          _createElementVNode("img", {
            class: "character-option-icon",
            src: option.icon
          }, null, 8, _hoisted_7),
          _createTextVNode(" " + _toDisplayString(option.name), 1)
        ]),
        _: 1
      }, 16, ["modelValue"]),
      _createVNode(_component_CodeHighlighter2, null, {
        html: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.htmlCode), 1)
        ]),
        js: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.jsCode), 1)
        ]),
        _: 1
      })
    ])
  ]))
}